AgrimarketServices.service('typeFixationBasesService', ['$rootScope', '$http', '$location', 'currentUserFactory', 'configurationFactory',
    function ($rootScope, $http, $location, currentUserFactory, configurationFactory) {

    	var SendRequest = function (configfile, callback) {
    		$http(configfile)
			    .success(function (data) {
			    	callback(data, null);
			    })
			    .error(function (data, status) {
			    	callback(data, status);
			    });
    	};

    	this.GetTypeFixationBases = function (callback) {
    		var config = {
    			method: 'GET',
                url: configurationFactory.Url['Api'] + 'TypeFixationBase/GetAll'
    		};
    		SendRequest(config, callback);
    	};
    }]);